/**
 * TeacherSettingsProvider
 *
 * Provider component that syncs teacher settings between local store
 * and the database. Provides context for accessing sync status.
 */

import { type ReactNode } from 'react';
import { useTeacherSettings } from '@/hooks/useTeacherSettings';
import { TeacherSettingsContext } from './TeacherSettingsContext';

interface TeacherSettingsProviderProps {
  children: ReactNode;
}

/**
 * Provider component that enables teacher settings synchronization
 */
export function TeacherSettingsProvider({ children }: TeacherSettingsProviderProps) {
  const settingsState = useTeacherSettings();

  return (
    <TeacherSettingsContext.Provider value={settingsState}>
      {children}
    </TeacherSettingsContext.Provider>
  );
}
